module.exports = __webpack_public_path__ + "img/intent_6.b79158aa.png";